<ngx-dynamic-hooks
        [content]="html"
        [options]="outletOptions"></ngx-dynamic-hooks>